import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
export function Team() {
  const team = [{
    initials: 'GD',
    name: 'Ginger',
    role: 'Strategy & GTM',
    bio: 'Product strategist. Helps founders nail positioning, pricing, and go-to-market.'
  }, {
    initials: 'AH',
    name: 'Ashley',
    role: 'Websites & Design',
    bio: 'Designer who builds websites, pitch decks, and brand materials that convert.'
  }, {
    initials: 'K',
    name: 'Kate',
    role: 'Automation & Tools',
    bio: 'Sets up CRMs, email automations, and workflows so you can focus on your business.'
  }, {
    initials: 'AP',
    name: 'Alicka',
    role: 'Content & Copy',
    bio: 'Copywriter and ghostwriter. Website copy, emails, LinkedIn content, and case studies.'
  }];
  return <section id="team" className="py-24 bg-cream" data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-172">
          <span className="text-terracotta font-medium tracking-wide uppercase text-sm" data-id="element-173">
            The Team
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-ink mt-3 mb-4" data-id="element-174">
            Four founders. Decades of experience.
          </h2>
          <p className="text-lg text-slate max-w-2xl mx-auto" data-id="element-175">
            We've built products, led teams, and scaled companies. Now we're
            here for you.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-176">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-177">
              <Card className="p-6 text-center h-full bg-white border-none" data-id="element-178">
                <div className="w-20 h-20 mx-auto bg-paper rounded-full flex items-center justify-center mb-4 border border-ink/5" data-id="element-179">
                  <span className="font-serif text-xl font-bold text-terracotta" data-id="element-180">
                    {member.initials}
                  </span>
                </div>
                <h3 className="text-xl font-serif font-bold text-ink mb-1" data-id="element-181">
                  {member.name}
                </h3>
                <p className="text-xs font-bold text-terracotta uppercase tracking-wide mb-3" data-id="element-182">
                  {member.role}
                </p>
                <p className="text-sm text-slate leading-relaxed" data-id="element-183">
                  {member.bio}
                </p>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}